// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"226":"fb04940e","290":"2e596850","441":"14e14015"}[chunkId] + ".chunk.js";
};